import React from 'react'
import { useTranslation } from 'lib/i18n'
import { connectBreadcrumb } from 'react-instantsearch-dom'

import Item from './Item'

import styles from './ConnectedBreadcrumb.module.css'

type ConnectedBreadcrumbProps = {
  items: { label: string; value: string }[]
  refine(value?: string): void
}

const ConnectedBreadcrumb = ({ items, refine }: ConnectedBreadcrumbProps) => {
  const { t } = useTranslation()

  return (
    <div className={styles.overflow}>
      <div className={styles.wrapper}>
        {!!items.length && (
          <Item
            onClick={refine}
            value={t('ConnectedBreadcrumb.firstBreadcrumb', 'All')}
          />
        )}

        {items.map((item) => (
          <Item
            key={item.value}
            onClick={() => {
              refine(item.value)
            }}
            value={item.label}
          />
        ))}
      </div>
    </div>
  )
}

export default connectBreadcrumb(ConnectedBreadcrumb)
